/** Shop contact — single source for conversion CTAs. */
export const PHONE_TEL = "tel:+19512961242";
export const PHONE_DISPLAY = "(951) 296-1242";

/** Google Maps query URL for driving directions. */
export const MAPS_DIRECTIONS_URL =
  "https://www.google.com/maps?q=42103+Rio+Nedo,+Ste+108,+Temecula,+CA+92590";
